(function () {
  const loginPanel = document.getElementById('login-panel');
  const recoverPanel = document.getElementById('recover-panel');

  if (!loginPanel || !recoverPanel) return;

  function showRecover() {
    loginPanel.classList.add('is-hidden');
    recoverPanel.classList.remove('is-hidden');
    document.getElementById('recover')?.focus();
  }

  function showLogin() {
    recoverPanel.classList.add('is-hidden');
    loginPanel.classList.remove('is-hidden');
    document.getElementById('login')?.focus();
  }

  // Show recover panel if URL hash is #recover on load
  if (window.location.hash === '#recover') {
    showRecover();
  } else {
    recoverPanel.classList.add('is-hidden');
  }

  document.querySelectorAll('a[href="#recover"]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      showRecover();
    });
  });

  document.querySelectorAll('a[href="#login"]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      showLogin();
    });
  });
})();